import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initializeUserStream = createAction(`${actionKey}.INIT`, (streamId, deviationId, type)=>({
        deviationId,
        type,
        streamId
    }));
